const constants = {
    CAN_MAP: "CanAddOrEditMapping",
    CAN_SELF_ASSESS: "CanSelfAssess",
    CAN_VIEW_PROGRESS_CHART: "CanViewProgressChart",
    CAN_VIEW_PENDING_LIST: "CanViewPendingList",
    CAN_APPROVE: "CanApprove"
};

export { constants as STATUS_PERMISSIONS_CONSTANTS };
